import React, { useState, useEffect } from "react";
import { About } from "./about";
import { Link } from "react-router-dom";
import JsonData from "../data/data.json";

export const Navigation = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header" style={{display: "flex"}}>
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="/">
          <img
                src="img/logo1.png"
                className="img-responsive"
                alt=""
                style={{ width: "25%", marginLeft: "20px" }}
              />
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="/" className="page-scroll">
                Accueil
              </a>
            </li>
            <li>
              <a href="/about" className="page-scroll">
                A propos
              </a>
            </li>
            <li>
              <a href="/services" className="page-scroll">
                Services
              </a>
            </li>
            <li>
              <a href="/prestations" className="page-scroll">
                Prestations
              </a>
            </li>
            <li>
              <a href="/contact" className="page-scroll">
                Contact
              </a>
            </li>
            
          </ul>
        </div>
      </div>
    </nav>
  );
};
